import React from 'react';
import {FaFlask, FaUser, FaBriefcase, FaTachometerAlt} from 'react-icons/fa';
import {GiEarthAmerica} from 'react-icons/gi';
import {useNavigate} from "react-router-dom";

const selected = '#e95a00';

function Footer(props) {

    const navigate = useNavigate();

    return (
        <div className="test">
        {/*<div className="footer">*/}
            {/*<div className="footer-item"*/}
            {/*     style={{color: props.page === 'home' ? selected : 'none'}}*/}
            {/*     onClick={() => navigate("/")}>*/}
            {/*    <div className="footer-icon"><GiEarthAmerica/></div>*/}
            {/*    <span className="footer-label">TexMed Cannabis</span>*/}
            {/*</div>*/}
            {/*<div className="footer-item"*/}
            {/*     style={{color: props.page === 'physicians' ? selected : 'none'}}*/}
            {/*     onClick={() => navigate("/physicians")}>*/}
            {/*    <div className="footer-icon"><FaUser/></div>*/}
            {/*    <span className="footer-label">Physician List</span>*/}
            {/*</div>*/}
            {/*<div className="footer-item"*/}
            {/*     style={{color: props.page === 'research' ? selected : 'none'}}*/}
            {/*     onClick={() => navigate("/research")}>*/}
            {/*    <div className="footer-icon"><FaBriefcase/></div>*/}
            {/*    <span className="footer-label">Research Form</span>*/}
            {/*</div>*/}
            {/*<div className="footer-item"*/}
            {/*     style={{color: props.page === 'market-data' ? selected : 'none'}}*/}
            {/*     onClick={() => navigate("/market-data")}>*/}
            {/*    <div className="footer-icon"><FaTachometerAlt/></div>*/}
            {/*    <span className="footer-label">Market Data</span>*/}
            {/*</div>*/}
            {/*<div className="footer-item"*/}
            {/*     style={{color: props.page === 'education' ? selected : 'none'}}*/}
            {/*     onClick={() => navigate("/education")}>*/}
            {/*    <div className="footer-icon"><FaFlask/></div>*/}
            {/*    <span className="footer-label">Education</span>*/}
            {/*</div>*/}
        </div>
    );
};


export default Footer;
